module.exports = __webpack_public_path__ + "img/pc-categories.7ddcfd9d.webp";